<template>
  <pdl-dialog
    :visible="isDialogVisible"
    modal
    modal-fade
    modal-append-to-body
    append-to-body
    close-on-press-escape
    :width="breakpointConfig.width"
    :top="breakpointConfig.top"
    :fullscreen="breakpointConfig.fullscreen"
    show-close
    z-index="160000011"
    @close="$emit('close')"
  >
    <pdl-tabs alignment="center" :value="initialTab">
      <pdl-tab-pane v-if="sizeChartData" name="size-chart">
        <h3 slot="label" class="heading heading--md m-0" v-html="bp('modalSizeChart')" />
        <size-dialog-chart-pane-content :base-properties="baseProperties" :size-chart-data="sizeChartData" />
      </pdl-tab-pane>
      <pdl-tab-pane v-if="isSizeFinderVisible" name="size-finder">
        <h3 slot="label" class="heading heading--md m-0" v-html="bp('modalSizeFinder')" />
        <size-dialog-finder-pane-content :size-link-guide="sizeLinkGuide" :base-properties="baseProperties" />
      </pdl-tab-pane>
    </pdl-tabs>
  </pdl-dialog>
</template>

<script>
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import {mapState} from 'vuex';
import SizeDialogChartPaneContent from '@/components/dialog/size/SizeDialogChartPaneContent';
import SizeDialogFinderPaneContent from '@/components/dialog/size/SizeDialogFinderPaneContent';
import viewSize from '@/mixins/view-size';

export default {
  components: {
    PdlDialog,
    PdlTabs,
    SizeDialogChartPaneContent,
    SizeDialogFinderPaneContent,
    PdlTabPane,
  },
  mixins: [viewSize],
  props: {
    sizeLinkGuide: {
      type: String,
      default: undefined,
    },
    isDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('pdp', ['sizeChartData']),
    breakpointConfig() {
      return this.viewBreakpointMoreThan('small')
        ? {width: '75vw', top: '15vh', fullscreen: false}
        : {width: '100vw', top: '0vh', fullscreen: true};
    },
    isSizeFinderVisible() {
      return this.sizeLinkGuide === 'size-finder';
    },
    initialTab() {
      if (this.sizeChartData) {
        return 'size-chart';
      } else if (this.isSizeFinderVisible) {
        return 'size-finder';
      }
      return undefined;
    },
  },
};
</script>
